import HeaderBox from 'component/PageModalHeaderBox'

import { StyledSwiper, StyledSwiperSlide } from './Styled'

import { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import Tabs from 'component/Tabs'
import { HeaderWrap, PageWrapperNonScroll } from 'commonStyledComponents'
import { TabsType } from 'component/Tabs/Styled'

interface TabItem {
  id: string
  name: string
}

interface PageTabsProps {
  uuid?: string
  children?: React.ReactNode
  title?: string
  tabs?: TabItem[]
  defaultValue?: string
  onClose?: (params?: any) => void
  onClickTab?: (tabName: string) => void
  onSwipeTab?: (tabName: string) => void
  [key: string]: any
}

export interface PageTabsHandle {
  changeTab: (tabName: string) => void
}

export default forwardRef<PageTabsHandle, PageTabsProps>(function PageTabs(
  {
    uuid,
    children,
    title = '',
    tabs = [],
    defaultValue,
    onClose,
    onClickTab,
    onSwipeTab,
    ...props
  },
  ref
) {
  const [tab, setTab] = useState<string | undefined>(defaultValue ?? tabs[0]?.id)

  const tabOrDefaultTab = tab ?? tabs[0]?.id

  const map: Record<string | number, string | number> = {}

  for (const [index, tab] of tabs.entries()) {
    map[tab.id] = index
    map[index] = tab.id
  }

  // 1. if we are jumping to slide due click on tab
  //  we assume we did not swipe to it, therefore not trigger swiper event
  // 2. or if we are not jump to anywhere, just emit normally
  const jumpTo = useRef<string | null>(null)

  const onProgress = (swiper: any) => {
    if (map[swiper.activeIndex] != null && map[swiper.activeIndex] !== tab) {
      if (jumpTo.current == null) {
        onSwipeTab?.(map[swiper.activeIndex] as string)
      }
      if (jumpTo.current === map[swiper.activeIndex]) {
        jumpTo.current = null
      }
      setTab(map[swiper.activeIndex] as string)
    }
  }

  const swiperRef = useRef<any>()

  const changeTab = (tabName: string) => {
    if (map[tabName] === swiperRef?.current?.swiper.realIndex) {
      setTab(tabName)
    } else {
      onClickTab?.(tabName)
      jumpTo.current = tabName
      swiperRef?.current?.swiper.slideTo(map[tabName])
    }
  }

  useImperativeHandle(ref, () => ({
    changeTab,
  }))

  return (
    <PageWrapperNonScroll {...props}>
      <HeaderWrap>
        <HeaderBox style={{ flexShrink: 0 }} headerTitle={title} modalId={uuid} onClose={onClose} />
        {tabs.length > 1 && (
          <Tabs options={tabs} type={TabsType.Underline} value={tabOrDefaultTab} onChange={changeTab} />
        )}
      </HeaderWrap>
      <StyledSwiper ref={swiperRef} onSlideChange={onProgress} cssMode>
        {children}
      </StyledSwiper>
    </PageWrapperNonScroll>
  )
})

export const PageTab = StyledSwiperSlide
